// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1DhSI","poster":"styles_poster__aAOxg"};